import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { getMotivosAusencia } from "../../api/motivosAusencia";
import axios from "axios";
import Modal from "../common/Modal";

export default function MotivosAusenciaSection() {
  const { token } = useContext(AuthContext);
  const [motivos, setMotivos] = useState([]);
  const [nuevoMotivo, setNuevoMotivo] = useState("");
  const [editando, setEditando] = useState(null);
  const [editNombre, setEditNombre] = useState("");
  const [mensaje, setMensaje] = useState("");

  const cargarMotivos = async () => {
    try {
      const data = await getMotivosAusencia(token);
      setMotivos(data);
    } catch {
      setMensaje("Error al cargar motivos");
    }
  };

  useEffect(() => { cargarMotivos(); }, []);

  const crearMotivo = async (e) => {
    e.preventDefault();
    if (!nuevoMotivo.trim()) return;
    try {
      await axios.post(
        `${import.meta.env.VITE_BACKEND_URL || "http://localhost:4000"}/api/motivos-ausencia`,
        { nombre: nuevoMotivo },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNuevoMotivo("");
      cargarMotivos();
    } catch {
      setMensaje("Error al crear motivo");
    }
  };

  const guardarEdicion = async (id) => {
    try {
      await axios.put(
        `${import.meta.env.VITE_BACKEND_URL || "http://localhost:4000"}/api/motivos-ausencia/${id}`,
        { nombre: editNombre },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setEditando(null);
      setEditNombre("");
      cargarMotivos();
    } catch {
      setMensaje("Error al editar motivo");
    }
  };

  const [motivoAEliminar, setMotivoAEliminar] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const eliminarMotivo = async (id) => {
    try {
      await axios.delete(
        `${import.meta.env.VITE_BACKEND_URL || "http://localhost:4000"}/api/motivos-ausencia/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMotivoAEliminar(null);
      setShowDeleteModal(false);
      cargarMotivos();
    } catch {
      setMensaje("Error al eliminar motivo");
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      {/* Header */}
      <div className="flex items-center gap-4 mb-6">
        <div className="rounded-xl bg-gray-100 w-12 h-12 flex items-center justify-center">
          <i className="fas fa-list-ul text-2xl text-gray-700"></i>
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-800">Motivos de Ausencia</h2>
          <p className="text-sm text-gray-600">Gestiona los motivos disponibles para las ausencias</p>
        </div>
      </div>

      {mensaje && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 flex items-center gap-2">
          <i className="fas fa-exclamation-circle"></i>
          {mensaje}
        </div>
      )}

      {/* Formulario de creación */}
      <form onSubmit={crearMotivo} className="mb-6">
        <label className="block text-sm font-semibold text-gray-700 mb-2">Nuevo Motivo</label>
        <div className="flex gap-3">
          <input
            type="text"
            value={nuevoMotivo}
            onChange={e => setNuevoMotivo(e.target.value)}
            className="border border-gray-300 rounded-lg px-4 py-2 flex-1 focus:ring-2 focus:ring-gray-400 focus:border-gray-500 outline-none transition"
            placeholder="Ej: Médico, Asuntos personales..."
          />
          <button 
            type="submit" 
            className="bg-gray-800 text-white px-6 py-2 rounded-lg hover:bg-gray-900 transition font-medium flex items-center gap-2"
          >
            <i className="fas fa-plus"></i>
            Agregar
          </button>
        </div>
      </form>

      {/* Lista de motivos */}
      <div>
        <h3 className="text-sm font-semibold text-gray-700 mb-3">Motivos Existentes</h3>
        {motivos.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <i className="fas fa-inbox text-4xl text-gray-300 mb-2"></i>
            <p>No hay motivos de ausencia registrados</p>
          </div>
        ) : (
          <ul className="divide-y divide-gray-200 border border-gray-200 rounded-lg">
            {motivos.map(motivo => (
              <li key={motivo._id} className="p-4 hover:bg-gray-50 transition flex items-center gap-3">
                {editando === motivo._id ? (
                  <>
                    <input
                      value={editNombre}
                      onChange={e => setEditNombre(e.target.value)}
                      className="border border-gray-300 rounded-lg px-3 py-2 flex-1 focus:ring-2 focus:ring-gray-400 focus:border-gray-500 outline-none"
                    />
                    <button 
                      onClick={() => guardarEdicion(motivo._id)} 
                      className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition font-medium flex items-center gap-2"
                    >
                      <i className="fas fa-check"></i>
                      Guardar
                    </button>
                    <button 
                      onClick={() => setEditando(null)} 
                      className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition font-medium text-gray-700"
                    >
                      Cancelar
                    </button>
                  </>
                ) : (
                  <>
                    <i className="fas fa-tag text-gray-400"></i>
                    <span className="flex-1 text-gray-800 font-medium">{motivo.nombre}</span>
                    <button 
                      onClick={() => { setEditando(motivo._id); setEditNombre(motivo.nombre); }} 
                      className="px-3 py-1.5 text-gray-700 hover:bg-gray-200 rounded-lg transition font-medium flex items-center gap-2"
                    >
                      <i className="fas fa-edit"></i>
                      Editar
                    </button>
                    <button 
                      onClick={() => { setMotivoAEliminar(motivo); setShowDeleteModal(true); }} 
                      className="px-3 py-1.5 text-red-600 hover:bg-red-50 rounded-lg transition font-medium flex items-center gap-2"
                    >
                      <i className="fas fa-trash-alt"></i>
                      Eliminar
                    </button>
                  </>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Modal de confirmación de borrado */}
      {showDeleteModal && (
        <Modal onClose={() => setShowDeleteModal(false)}>
          <div className="p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                <i className="fas fa-exclamation-triangle text-red-600 text-xl"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-800">Eliminar Motivo</h3>
            </div>
            <p className="text-gray-700 mb-6">
              ¿Estás seguro de que quieres eliminar el motivo <strong>"{motivoAEliminar?.nombre}"</strong>? 
              Esta acción no se puede deshacer.
            </p>
            <div className="flex justify-end gap-3">
              <button 
                onClick={() => setShowDeleteModal(false)} 
                className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition font-medium"
              >
                Cancelar
              </button>
              <button 
                onClick={() => eliminarMotivo(motivoAEliminar._id)} 
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition font-medium flex items-center gap-2"
              >
                <i className="fas fa-trash-alt"></i>
                Eliminar
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
